<igx-grid #enroll [data]="this.data | sorting" igxGridState [moving]="true" (columnMoving)="columnMoving($event)">
    <igx-grid-toolbar>
        <igx-grid-toolbar-actions>
            <igx-checkbox [checked]="showAll" (change)="filterRequests($event)">Всички заявки</igx-checkbox>
        </igx-grid-toolbar-actions>
    </igx-grid-toolbar>
    <igx-column width="50px" [editable]="false" [resizable]="false" [pinned]="true">
        <ng-template igxCell let-cell="cell">
            @switch (cell.row.data.state){
            @case (0) {
            <button title="Обработи" igxIconButton="flat"
                (click)="startProcessEnrollment(enrollmentDialog, cell.row.data)">
                <igx-icon>person_add</igx-icon>
            </button>
            }
            @case (1) {
            <button title="Обработена" igxIconButton="flat"
                (click)="startProcessEnrollment(enrollmentDialog, cell.row.data)">
                <igx-icon style="color: green;">done</igx-icon>
            </button>
            }
            @case (2) {
            <button title="Възстанови" igxIconButton="flat" (click)="restore(cell.row.data)">
                <igx-icon>restore_from_trash</igx-icon>
            </button>
            }}
        </ng-template>
    </igx-column>
    <igx-column width="50px" [editable]="false" [resizable]="false" [pinned]="true">
        <ng-template igxCell let-cell="cell">
            <button title="Допълнителна информация" igxIconButton="flat"
                (click)="showInfo(cell.row.data, info, infoDialog)">
                <igx-icon>info</igx-icon>
            </button>
        </ng-template>
    </igx-column>
    <igx-column field="timeCreate" header="Заявена на" dataType="date" [sortable]="true" [disablePinning]="true"
        [resizable]="true"></igx-column>
    <igx-column field="program" header="Програма" [sortable]="true" [disablePinning]="true" [resizable]="true">
        <ng-template igxCell let-cell="cell">
            <span>{{renderProgram(cell)}}</span>
        </ng-template>
    </igx-column>
    <igx-column field="date" header="Начална дата" dataType="date" [sortable]="true" [disablePinning]="true"
        [resizable]="true"></igx-column>
    <igx-column field="kidName" header="Име дете" [sortable]="true" [disablePinning]="true"
        [resizable]="true"></igx-column>
    <igx-column field="parentName" header="Име родител" [sortable]="true" [disablePinning]="true"
        [resizable]="true"></igx-column>
    <igx-column field="parentEmail" header="Имейл родител" [sortable]="true" [disablePinning]="true"
        [resizable]="true"></igx-column>
    <igx-column field="parentPhone" header="Телефон родител" [sortable]="true" [disablePinning]="true"
        [resizable]="true"></igx-column>
</igx-grid>
<igx-dialog #enrollmentDialog>
    <app-process-enrollment (done)="enrollmentDialog.close()" #enrollment></app-process-enrollment>
</igx-dialog>
<igx-dialog #infoDialog>
    <app-info-enrollment #info></app-info-enrollment>
</igx-dialog>